import { useEffect, useState } from 'react';

import { useIntlWrapperContext } from '../../../Helpers/IntlWrapperProvider';
import useFetchWrapper, { HttpResponse } from '../../../Helpers/useFetchWrapper';

import {
	Props,
	TableData,
	TabStatus,
	UsersResponse
} from './UsersTab.model';

export const pageSize = 10;

const useUsersTab = ({ filters }: Props) => {
	const [ users, setUsers ] = useState<TableData[]>([]);
	const [ usersPagination, setUsersPagination ] = useState({ page: 1, size: pageSize, total: 0 });
  const [ tabStatus, setTabStatus ] = useState<TabStatus>(TabStatus.Loading);

	const { getI18nCountryName } = useIntlWrapperContext();
	const { get, post } = useFetchWrapper();

  useEffect(() => {
		getUsers();
	}, [usersPagination.page]);

	useEffect(() => {

		if (usersPagination.page > 1) {
			setUsersPagination({ ...usersPagination, page: 1, })
		} else {
			getUsers();
		}
	}, [ filters ]);

	const getUsers = async () => {

		setTabStatus(TabStatus.Loading);

		const res: HttpResponse<UsersResponse> = await get(`/user/all?page=${usersPagination.page}&size=${usersPagination.size}&${filters}`);
		
		if (res.parsedBody) {
			const { count, users } = res.parsedBody;
			
				setUsers(users.map((item, index) => ({
					id: item.userId,
					imageId: item.imageId,
					isActive: item.isActive,
					key: `${index}`,
					location: item.location ? getI18nCountryName(item.location) : '',
					name: `${item.firstName} ${item.lastName}`,
					userType: item.role,
				})) || []);

			setUsersPagination({
				...usersPagination,
				total: count,
			});
			setTabStatus(TabStatus.Loaded);
		} else {
			setTabStatus(TabStatus.Error);
		}
	}

	const onChangeUsersPagination = (page: number) => {
		setUsersPagination({ ...usersPagination, page, });
	}
	
	const reinviteUser = async (userId: string) => {
		await post(`/user/reinvite/${userId}`, {});
	};

	return {
		getUsers,
    onChangeUsersPagination,
		reinviteUser,
    state: {
      tabStatus,
      users,
      usersPagination
    }
  };
}

export default useUsersTab;